import { FC } from "react";

import { FormattedMessage } from "react-intl";

import { Button } from "@/components/atoms/Button";
import Share from "@/icons/__generated__/Share/Share20";
import ShareLarge from "@/icons/__generated__/Share/Share24";
import type { ListingShareButtonProps } from "~/components/gallery/photo-gallery.types";
import { useShareModal } from "~/modals";

export const ListingShareButton: FC<ListingShareButtonProps> = ({
  origin,
  fbShare,
  twitterShare,
  emailShare,
  appearance = "black",
  variant = "default",
  isMDScreen,
  useLargeIcon = false,
  analyticData,
}) => {
  const { openModal: openShareModal } = useShareModal();

  const handleOnSocialButtonClick = (label: string) =>
    analyticData &&
    window.analyticsIntegrations.shareBtnClick(analyticData, origin, label);

  const handleOpenShareModal = () => {
    openShareModal({
      emailShare,
      fbShare,
      twitterShare,
      variant: "listing",
      onSocialButtonClick: handleOnSocialButtonClick,
    });
  };

  return (
    <Button
      appearance={appearance}
      className="[&>span]:tw-flex [&>span]:tw-items-center [&>span]:tw-gap-4"
      variant={variant}
      iconOnly={!isMDScreen}
      onClick={handleOpenShareModal}
    >
      {useLargeIcon ? (
        <ShareLarge data-testing-id="icon-share-large" />
      ) : (
        <Share data-testing-id="icon-share" />
      )}
      {isMDScreen && (
        <FormattedMessage
          id="listing.listing_main.listing_share_button"
          defaultMessage="Share"
        />
      )}
    </Button>
  );
};
